<template>
  <div :class="wrapperClass">
    <span class="badge document-queued-single-badge">
      <i
        v-if="loading"
        data-testid="file-badge-loading"
        class="fa fa-spin fa-spinner"
      />
      <span class="document-queued-single-name">{{ name }}</span>
      <span class="document-queued-single-progress">
        <span v-if="percentage" class="document-queued-single-percentage">
          {{ percentage }}
          <span>{{ I18n.t('components.document.queued_single.of') }}</span>
        </span>
        <span class="document-queued-single-size">
          {{ formattedBytes }}
        </span>
      </span>
      <i
        class="fa fa-times"
        data-testid="file-badge-remove"
        @click="onRemove(id)"
      />
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { formatBytes } from '@app/utils/file-helpers'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'FileBadge',
})

interface Props {
  progress: number | string
  id?: string
  name: string
  loading?: boolean
  fileSize?: number
  onRemove: (_id: string) => void
  wrapperClass?: string
}

const I18n = window.I18n

const props = withDefaults(defineProps<Props>(), {
  id: '',
  fileSize: 0,
  wrapperClass: '',
})

const percentage = computed(() => {
  return props.progress ? `${props.progress}%` : null
})

const formattedBytes = computed(() => {
  return formatBytes(props.fileSize)
})
</script>
